module.exports = __webpack_public_path__ + "static/media/Οδοιπορικό Ελληνική Κοινότητα Κωφών..d09ef805.vtt";